import { createHandlerChainRunnerOptionalParameter, Handler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    ClearForm
} from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/ClearForm";

replaceInChain(chain, ClearForm, props => {   
    props.dispatch({
        type: "Components/ContactUsForm/ClearForm",
    });

    /* Verndale customization */
    document.querySelectorAll('[role=checkbox]').forEach(el => {
        (el as HTMLInputElement).ariaChecked = "false";
    });
    /* End Verndale customization */
});
